export interface FinanceSubScreen {
  id: string;
  name: string;
  desc?: string;
}

export interface FinanceGroup {
  id: string;
  name: string;
  subScreens?: FinanceSubScreen[];
}

export const FINANCE_GROUPS: FinanceGroup[] = [
  {
    id: 'panel_principal',
    name: 'PANEL PRINCIPAL'
  },
  /*
  {
    id: 'acciones_rapidas',
    name: 'ACCIONES RÁPIDAS (+ Nuevo)',
    subScreens: [
      { id: 'hub_acciones', name: 'Catálogo de Acciones', desc: 'Panel con las 13 acciones de creación rápida' },
      { id: 'crear_factura_emitida', name: 'Factura emitida', desc: 'VENTAS: Crear factura de venta' },
      { id: 'crear_presupuesto', name: 'Presupuesto', desc: 'VENTAS: Emitir presupuesto comercial' },
      { id: 'crear_recibo_venta', name: 'Recibo de venta', desc: 'VENTAS: Recibo de cobro al contado' },
      { id: 'crear_nota_credito', name: 'Nota de crédito', desc: 'VENTAS: Abono o devolución' },
      { id: 'crear_cobro', name: 'Cobro', desc: 'VENTAS: Registrar cobro de cliente' },
      { id: 'crear_factura_recibida', name: 'Factura recibida', desc: 'COMPRAS: Factura de proveedor' },
      { id: 'crear_gasto', name: 'Gasto directo', desc: 'COMPRAS: Registrar gasto menor' },
      { id: 'crear_pago_proveedor', name: 'Pago a proveedor', desc: 'COMPRAS: Orden de pago bancario' },
      { id: 'crear_deposito', name: 'Depósito bancario', desc: 'TESORERÍA: Inyección de fondos' },
      { id: 'crear_asiento_manual', name: 'Asiento manual', desc: 'CONTABILIDAD: Asiento de doble entrada' },
      { id: 'crear_cliente', name: 'Cliente', desc: 'MAESTROS: Alta nuevo cliente' },
      { id: 'crear_proveedor', name: 'Proveedor / Acreedor', desc: 'MAESTROS: Alta nuevo proveedor' },
      { id: 'crear_articulo_servicio', name: 'Artículo / Servicio', desc: 'MAESTROS: Alta nuevo ítem' }
    ]
  },
  */
  {
    id: 'tesoreria_bancos',
    name: 'TESORERÍA Y BANCOS',
    subScreens: [
      { id: 'cuentas_bancarias', name: 'Cuentas bancarias', desc: 'Posición de tesorería y cuentas corrientes' },
      { id: 'cuaderno_43', name: 'Cargar bancos manual', desc: 'Importación y procesamiento de ficheros bancarios Norma 43' },
      { id: 'saldos_bancos', name: 'Visualización de saldos', desc: 'Consulta de saldos de las cuentas bancarias' },
      { id: 'diario', name: 'Entrar apunte cuenta mayor', desc: 'Asiento manual de doble entrada en cuentas de mayor' },
      { id: 'compensacion_partidas', name: 'Compensación de partidas manual', desc: 'Compensación manual de partidas abiertas' },
      { id: 'conciliacion_bancaria', name: 'Conciliación bancaria', desc: 'Casación automática y manual de extractos y asientos' },
      { id: 'sepa', name: 'Cobros SEPA (Norma 19)', desc: 'Remesas bancarias de adeudos directos' }
      // { id: 'cuenta_intermedia', name: 'Cuenta intermedia de consolidación', desc: 'Cuenta puente configurable para saldos en tránsito y descuadres' },
      // { id: 'depositos', name: 'Depósitos', desc: 'Registro de depósitos e inyecciones de capital' },
      // { id: 'creditos', name: 'Préstamos y créditos', desc: 'Financiación bancaria y cuadros de amortización' }
    ]
  },
  {
    id: 'deudores',
    name: 'DEUDORES (CLIENTES)',
    subScreens: [
      { id: 'clientes', name: 'Crear / modificar deudor', desc: 'Maestro de clientes con datos fiscales y cuenta PGC 430' },
      { id: 'partidas_deudor', name: 'Partidas deudor', desc: 'Partidas abiertas y compensadas por cliente' },
      { id: 'facturas_emitidas', name: 'Factura manual', desc: 'Histórico y estado de facturación a clientes' },
      { id: 'notas_credito', name: 'Abono manual', desc: 'Abonos por devoluciones y saldos a favor' },
      { id: 'compensar_deudor', name: 'Compensar deudor', desc: 'Compensación de partidas de cliente' },
      { id: 'cobros', name: 'Entrada de pago manual', desc: 'Liquidación y registro de cobros' },
      { id: 'salida_pagos_deudor', name: 'Contabilizar salida de pagos', desc: 'Pagos a clientes: devoluciones y saldos a favor' },
      { id: 'anulacion_deudor', name: 'Anulación individual', desc: 'Anulación de documentos de cliente' },
      { id: 'anular_compensacion_deudor', name: 'Anular compensación', desc: 'Deshacer compensaciones de cliente' },
      { id: 'creditos_deudor', name: 'Gestión de créditos de deudor', desc: 'Gestión de créditos de deudor para recibo domiciliado' },
      { id: 'sepa', name: 'Programa de pagos', desc: 'Generación de ficheros de recibos (remesas Norma 19)' },
      { id: 'facturacion_electronica', name: 'Facturación electrónica', desc: 'Emisión y envío de facturas electrónicas' }
      // { id: 'resumen_ventas', name: 'Resumen de ventas', desc: 'Indicadores, facturación y estados comerciales' },
      // { id: 'presupuestos', name: 'Presupuestos', desc: 'Presupuestos comerciales a librerías y distribuidores' },
      // { id: 'recibos_venta', name: 'Recibos de venta', desc: 'Ventas directas y recibos al contado' },
      // { id: 'articulos_servicios', name: 'Artículos y servicios', desc: 'Maestro de libros, publicaciones y servicios con IVA' }
    ]
  },
  {
    id: 'acreedores',
    name: 'ACREEDORES (PROVEEDORES)',
    subScreens: [
      { id: 'proveedores', name: 'Crear / modificar acreedor', desc: 'Maestro de proveedores y acreedores con cuenta 400/410' },
      { id: 'partidas_acreedor', name: 'Partidas acreedor', desc: 'Partidas abiertas y compensadas por proveedor' },
      { id: 'saldos_acreedor', name: 'Visualizar saldos', desc: 'Saldos por proveedor y acreedor' },
      { id: 'pagos_proveedores', name: 'Salida de pagos', desc: 'Gestión y liquidación de pagos pendientes' },
      { id: 'programa_pagos_acreedor', name: 'Programa de pagos', desc: 'Remesas de pagos a acreedores (Norma 34)' },
      { id: 'compensar_acreedor', name: 'Compensar', desc: 'Compensación de partidas de proveedor' },
      { id: 'facturas_recibidas', name: 'Registro de factura', desc: 'Facturas de suministros, imprenta y servicios' },
      { id: 'abonos_acreedor', name: 'Registro de abono', desc: 'Abonos y rectificativas recibidas de proveedores' }
      // { id: 'resumen_gastos', name: 'Resumen de gastos', desc: 'Análisis de compras, costes editoriales y gastos operativos' },
      // { id: 'gastos', name: 'Gastos directos', desc: 'Gastos directos menores y caja chica' }
    ]
  },
  {
    id: 'libro_mayor',
    name: 'LIBRO MAYOR',
    subScreens: [
      { id: 'diario', name: 'Contabilización general', desc: 'Asiento manual de doble entrada en cuentas de mayor' },
      { id: 'contabilizar_modelo', name: 'Contabilizar con modelo', desc: 'Asientos a partir de un modelo de imputación' },
      { id: 'mayor', name: 'Visualizar partidas', desc: 'Extractos agrupados por cuenta contable PGC' },
      { id: 'compensar_mayor', name: 'Compensar cuentas mayor', desc: 'Compensación de partidas de cuentas de mayor' },
      { id: 'saldos_mayor', name: 'Visualizar saldos', desc: 'Saldos por cuenta de mayor' },
      { id: 'anular_documentos', name: 'Anular documentos', desc: 'Anulación de documentos contables' },
      { id: 'anular_compensacion_mayor', name: 'Anular compensación', desc: 'Deshacer compensaciones de cuentas de mayor' },
      { id: 'modelos_imputacion', name: 'Modelos de imputación', desc: 'Plantillas de reparto para contabilizar con modelo' },
      { id: 'tpv', name: 'TPV', desc: 'Ventas por terminal punto de venta' }
      // { id: 'diario_docs', name: 'Diario de documentos', desc: 'Trazabilidad de apuntes por documento original' }
    ]
  },
  {
    id: 'balances',
    name: 'BALANCES',
    subScreens: [
      { id: 'balance_sumas', name: 'Balance de sumas y saldos', desc: 'Cuadrante oficial de comprobación de sumas y saldos' },
      { id: 'pyg', name: 'Pérdidas y ganancias', desc: 'Cuenta de pérdidas y ganancias del ejercicio (Grupos 6 y 7)' },
      { id: 'balance_situacion', name: 'Balance de situación', desc: 'Activo, Pasivo y Patrimonio Neto a fecha de hoy' },
      { id: 'mayor', name: 'Libro mayor', desc: 'Extractos agrupados por cuenta contable PGC' },
      { id: 'review_entries', name: 'Diario', desc: 'Auditoría cronológica y revisión de asientos contables' }
    ]
  },
  {
    id: 'sii',
    name: 'SII',
    subScreens: [
      { id: 'sii_edocuments', name: 'Crear eDocuments', desc: 'Creación manual de eDocuments para la AEAT' },
      { id: 'sii_listas', name: 'Crear listas eDoc para SII', desc: 'Listas manuales de eDocuments para el SII' },
      { id: 'sii_cockpit', name: 'Cockpit de eDocument', desc: 'Seguimiento del envío de eDocuments' }
    ]
  },
  {
    id: 'activos',
    name: 'ACTIVOS FIJOS',
    subScreens: [
      { id: 'activos_fijos', name: 'Crear activo fijo / contabilizar amortización', desc: 'Alta de inmovilizado y contabilización de la amortización' },
      { id: 'activo_con_acreedor', name: 'Contabilización AF con acreedor', desc: 'Alta de activo fijo desde la factura del proveedor' },
      { id: 'informe_amortizacion', name: 'Informe de amortización', desc: 'Valores de adquisición y amortización del inmovilizado por cuenta de mayor' },
      { id: 'cierre', name: 'Cierre del ejercicio', desc: 'Regularización y cierre mensual o fin de ejercicio' },
      { id: 'depreciation_methods', name: 'Claves de amortización', desc: 'Catálogo de métodos y tasas de amortización' }
    ]
  },
  {
    id: 'impuestos_aeat',
    name: 'IMPUESTOS (AEAT)',
    subScreens: [
      { id: 'modelo_111', name: 'Modelo 111 (retenciones)', desc: 'Retenciones trimestrales de IRPF a profesionales y nóminas' },
      { id: 'modelo_349', name: 'Modelo 349', desc: 'Declaración recapitulativa de operaciones intracomunitarias' },
      { id: 'modelos_iva', name: 'Modelos IVA (322, 353, 300)', desc: 'Autoliquidaciones de IVA' },
      { id: 'contabilizacion_impuestos', name: 'Contabilización manual de impuestos', desc: 'Asientos manuales de liquidación de impuestos' }
      // { id: 'resumen_fiscal', name: 'Resumen fiscal', desc: 'Visión fiscal consolidada, obligaciones trimestrales y anuales' },
      // { id: 'modelo_303', name: 'Modelo 303 (IVA)', desc: 'Autoliquidación trimestral del Impuesto sobre el Valor Añadido' },
      // { id: 'modelo_130', name: 'Modelo 130', desc: 'Pago fraccionado del IRPF para estimación directa' },
      // { id: 'vencimientos_fiscales', name: 'Vencimientos fiscales', desc: 'Calendario tributario oficial de la AEAT' },
      // { id: 'tipos_impuestos', name: 'Tipos de impuestos', desc: 'Maestro de tipos de IVA y retenciones IRPF' }
    ]
  },
  {
    id: 'cierres',
    name: 'CIERRE',
    subScreens: [
      { id: 'cierre', name: 'Cierre de periodos mes', desc: 'Regularización y cierre mensual o fin de ejercicio' },
      { id: 'arrastre_deudores', name: 'Arrastre saldos deudores', desc: 'Traspaso de saldos de clientes al nuevo ejercicio' },
      { id: 'arrastre_acreedores', name: 'Arrastre saldos acreedores', desc: 'Traspaso de saldos de proveedores al nuevo ejercicio' },
      { id: 'arrastre', name: 'Arrastre saldos cuentas mayor', desc: 'Consolidación anual y asiento de apertura' }
    ]
  },
  {
    id: 'informes',
    name: 'CONTROLLING',
    subScreens: [
      { id: 'reparto_costes', name: 'Reparto de costes', desc: 'Reparto de costes de las unidades no productivas' },
      { id: 'informe_costes', name: 'Informe de costes', desc: 'Análisis de costes' },
      { id: 'informe_ventas', name: 'Informe de ventas', desc: 'Análisis de ventas' },
      { id: 'cuadro_mandos', name: 'Cuadro de mandos financiero', desc: 'Indicadores financieros principales' }
      // { id: 'analitica', name: 'Analítica', desc: 'Análisis de tendencias de mercado y rendimiento de catálogo' }
    ]
  },
  {
    id: 'configuracion',
    name: 'MAESTROS',
    subScreens: [
      { id: 'plan_cuentas', name: 'Plan general de contabilidad y creación de cuentas', desc: 'Maestro de cuentas del Plan General Contable (PGC)' },
      { id: 'formas_pago', name: 'Vías de pago', desc: 'Maestro de instrumentos financieros y cuentas PGC' },
      { id: 'condiciones_pago', name: 'Condiciones de pago', desc: 'Maestro de plazos y términos comerciales' },
      { id: 'series_facturacion', name: 'Series de facturación', desc: 'Series con las que facturan los TPV de las tiendas' }
      // { id: 'numeraciones', name: 'Numeraciones y series', desc: 'Series de facturas, presupuestos, recibos y pedidos' }
    ]
  },
  {
    id: 'auditoria',
    name: 'AUDITORÍA',
    subScreens: [
      { id: 'stock_valorado', name: 'Informes por almacén de stock valorado', desc: 'Valoración de existencias por almacén' },
      { id: 'indice_rotacion', name: 'Índice de rotación', desc: 'Rotación de existencias' },
      { id: 'listado_acreedores', name: 'Listado acreedores', desc: 'Informe de proveedores y acreedores' },
      { id: 'listado_deudores', name: 'Listado deudores', desc: 'Informe de clientes' },
      { id: 'partidas_abiertas_acreedores', name: 'Partidas abiertas acreedores', desc: 'Partidas pendientes de pago a proveedores' },
      { id: 'partidas_abiertas_deudores', name: 'Partidas abiertas deudores', desc: 'Partidas pendientes de cobro a clientes' }
    ]
  }
];

// Vista de FinancialSuite para cada subpantalla; las que no están muestran "En preparación"
export const SUBSCREEN_TO_SUITE_MENU: Record<string, string> = {
  crear_factura_recibida: 'factura_recibida',
  crear_asiento_manual: 'diario',
  facturas_emitidas: 'facturas_historial',
  recibos_venta: 'recibos',
  pagos_proveedores: 'pagos',
  // Ahora va a forms/BankReconciliationForm; se deja por si hay que volver a la de FinancialSuite
  // conciliacion_bancaria: 'bancos',
  sepa: 'sepa',
  creditos: 'creditos',
  review_entries: 'review_entries',
  mayor: 'mayor',
  diario_docs: 'diario_docs',
  diario: 'diario',
  balance_sumas: 'balance_sumas',
  balance_situacion: 'balance_situacion',
  pyg: 'pyg',
  arrastre: 'arrastre',
  cierre: 'cierre',
  // Ahora va a views/FixedAssetsView (SUBSCREEN_VIEWS); se deja por si hay que volver a la de FinancialSuite
  // activos_fijos: 'activos_fijos',
  depreciation_methods: 'depreciation_methods',
  modelo_303: 'impuestos',
  modelo_111: 'impuestos'
};

// Acciones rápidas
export type QuickActionCategory = 'VENTAS' | 'COMPRAS Y GASTOS' | 'TESORERÍA' | 'CONTABILIDAD' | 'MAESTROS';

export interface QuickActionItem {
  id: string;
  subScreenId: string;
  name: string;
  category: QuickActionCategory;
  description: string;
  badge: string;
}

export const QUICK_ACTION_CATEGORIES: { key: QuickActionCategory; label: string; desc: string }[] = [
  { key: 'VENTAS', label: 'VENTAS', desc: 'Facturación, cotizaciones, recibos y cobros de clientes' },
  { key: 'COMPRAS Y GASTOS', label: 'COMPRAS Y GASTOS', desc: 'Facturas de proveedores, gastos menores y pagos' },
  { key: 'TESORERÍA', label: 'TESORERÍA', desc: 'Inyecciones de liquidez y depósitos bancarios' },
  { key: 'CONTABILIDAD', label: 'CONTABILIDAD', desc: 'Apuntes manuales de doble entrada en Libro Diario' },
  { key: 'MAESTROS', label: 'MAESTROS', desc: 'Altas en ficheros maestros del sistema' }
];

export const QUICK_ACTIONS_13: QuickActionItem[] = [
  { id: 'act_factura_emitida', subScreenId: 'crear_factura_emitida', name: 'Crear Factura Emitida', category: 'VENTAS', description: 'Generar factura de venta formal con IVA desglosado y asiento contable automático', badge: 'Facturación' },
  { id: 'act_presupuesto', subScreenId: 'crear_presupuesto', name: 'Crear Presupuesto', category: 'VENTAS', description: 'Emitir presupuesto comercial valorado para librerías o instituciones educativas', badge: 'Comercial' },
  { id: 'act_recibo_venta', subScreenId: 'crear_recibo_venta', name: 'Crear Recibo de Venta', category: 'VENTAS', description: 'Registrar venta directa de libros cobrada al contado en mostrador o TPV', badge: 'Contado' },
  { id: 'act_nota_credito', subScreenId: 'crear_nota_credito', name: 'Crear Nota de Crédito', category: 'VENTAS', description: 'Emitir abono por devolución de ejemplares o rectificación de factura', badge: 'Abono' },
  { id: 'act_cobro', subScreenId: 'crear_cobro', name: 'Registrar Cobro', category: 'VENTAS', description: 'Liquidar cobro recibido de cliente contra factura pendiente y cuenta bancaria', badge: 'Cobro' },
  { id: 'act_factura_recibida', subScreenId: 'crear_factura_recibida', name: 'Registrar Factura Recibida', category: 'COMPRAS Y GASTOS', description: 'Cargar factura de compra a imprenta, papelera o acreedor de servicios', badge: 'Gasto' },
  { id: 'act_gasto', subScreenId: 'crear_gasto', name: 'Registrar Gasto Directo', category: 'COMPRAS Y GASTOS', description: 'Registrar gasto operativo menor o compra directa por caja/tarjeta', badge: 'Caja Chica' },
  { id: 'act_pago_proveedor', subScreenId: 'crear_pago_proveedor', name: 'Registrar Pago a Proveedor', category: 'COMPRAS Y GASTOS', description: 'Emitir orden de pago por transferencia y cancelar deuda en cuenta 400', badge: 'Pago' },
  { id: 'act_deposito', subScreenId: 'crear_deposito', name: 'Registrar Depósito Bancario', category: 'TESORERÍA', description: 'Ingresar fondos en cuenta corriente 572 procedentes de caja o aportación', badge: 'Bancos' },
  { id: 'act_asiento_manual', subScreenId: 'crear_asiento_manual', name: 'Crear Asiento Manual', category: 'CONTABILIDAD', description: 'Asiento contable de doble entrada (Debe y Haber) con validación estricta de cuadre', badge: 'Libro Diario' },
  { id: 'act_cliente', subScreenId: 'crear_cliente', name: 'Alta de Cliente', category: 'MAESTROS', description: 'Dar de alta una nueva librería, distribuidor o cliente con cuenta 430', badge: 'Ficha Cliente' },
  { id: 'act_proveedor', subScreenId: 'crear_proveedor', name: 'Alta de Proveedor / Acreedor', category: 'MAESTROS', description: 'Dar de alta suministrador o acreedor con cuenta contable 400 / 410', badge: 'Ficha Proveedor' },
  { id: 'act_articulo_servicio', subScreenId: 'crear_articulo_servicio', name: 'Alta de Artículo / Servicio', category: 'MAESTROS', description: 'Registrar un nuevo libro, monografía, suscripción o servicio con IVA y precio', badge: 'Catálogo' }
];

// Aplica un orden guardado: lo nuevo va al final y lo que ya no existe se descarta.
export const applyOrder = <T extends { id: string }>(items: T[], savedIds: string[] = []): T[] => {
  const known = savedIds
    .map(id => items.find(item => item.id === id))
    .filter((item): item is T => !!item);
  return [...known, ...items.filter(item => !known.includes(item))];
};
